import { css } from "../../../../../styled-system/css";

export const styles = {
  imageWrapper: () =>
    css({
      maxWidth: "528px",
      width: "100%",
    }),
  imageMobile: () =>
    css({
      desktop: {
        display: "none",
      },
    }),
  imageDesktop: () =>
    css({
      display: "none",
      desktop: {
        display: "initial",
      },
    }),
};
